<!--
 * @Descripttion: 
 * @version: 
 * @Author: Francis
 * @Date: 2022-07-30 16:23:02
 * @LastEditors: Francis
 * @LastEditTime: 2022-08-02 15:01:54
-->
<template>
  <div class="parts">
    <div class="head">
      <p class="title">产品配件</p>
      <van-tabs type="line" v-model="active" background="#44b1f9" color="#fff" title-active-color="#fff"
        title-inactive-color="#fff" @click="onClick">
        <van-tab title="接收" :name='0'></van-tab>
        <!-- <van-tab title="分派" :name='2'></van-tab> -->
        <van-tab title="核销" :name='1'></van-tab>
      </van-tabs>
    </div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" class="table_view">
        <div class="table_cell" v-for="(items, index) in tableList" :key="index">
          <template v-if="active == 0">
            <div class="oddNumbers">
              <img class="imgicon" src="../../../assets/workOrder/titles.png" alt="">
              <span>邮寄单号：{{ items.mailingNo }}</span>
            </div>
            <div v-for="item in items.jxcFittings" :key="item.id" class="bottombox">

              <div class="head_info">
                <div class="typebox">
                  <div :class="item.type == 1 ? 'type' : 'type1'">
                    <!-- <p>配件类型</p> -->
                  </div>
                  <p class="sub-title">{{ item.category }}</p>
                </div>

                <!-- <div class="state1" v-if="item.fittingState == 2" @click="onClickCell(item)">确认接收</div> -->
                <div class="state3" v-if="item.fittingState == 3"></div>
              </div>
              <div style="padding-left: 15px;">
                <p class="num" v-if="!item.csn">数量：<span>{{ item.operateNum }}</span></p>
                <p class="num" v-if="item.fittingState == 3 && item.status == 1">确认数量：<span>{{ item.receiveNum }}</span>
                </p>
                <p class="num" v-if="item.csn">SN码：<span>{{ item.csn }}</span></p>
                <p class="starTime">出库时间：<span>{{ item.operateTime }}</span></p>
                <p v-if="item.fittingState == 3" class="starTime">
                  接收时间：<span>{{ item.receiveTime }}</span>
                </p>
                <div class="starTimedggbox" v-if="item.fittingState == 2">
                  <div class="starTimedgg" @click="onClickCell(item)">确认接收</div>

                </div>

              </div>
              <van-divider :hairline="false" />
            </div>

          </template>
          <template v-if="active == 1">
            <!-- <div class="oddNumbers">
              <img class="imgicon" src="../../../assets/workOrder/titles.png" alt="">
              <span>邮寄单号：{{ items.mailingNo }}</span>
            </div> -->
            <div class="head_info">
              <div class="typebox">
                <div :class="items.type == 1 ? 'type' : 'type1'">
                  <!-- <p>配件类型</p> -->
                </div>
                <p class="sub-title">{{ items.fittingCategory }}</p>

              </div>
              <!-- <div class="type">
                
              </div> -->
              <div class="state1" v-if="items.state == 1" @click="onClickCell2(items)">取消申请</div>
              <div class="state2" v-if="items.state !== 1">已核销</div>
            </div>
            <p class="num" v-if="!items.csn">数量：<span>{{ items.applyNum }}</span></p>
            <p class="num" v-if="items.csn">SN码：<span>{{ items.csn }}</span></p>
            <p class="starTime">申请时间：<span>{{ items.applyTime }}</span></p>
            <p v-if="items.state !== 1" class="starTime">
              核销时间：<span>{{ items.verificationTime }}</span>
            </p>
          </template>
          <template v-if="active == 2">
            <div class="bottombox">
              <div class="head_info">
                <div class="typebox">
                  <div :class="items.type == 1 ? 'type' : 'type1'">
                    <!-- <p>配件类型</p> -->
                  </div>
                  <p class="sub-title">{{ items.category }}</p>
                </div>
              </div>
              <div class="botts">
                <div class="botts1">分派时间：<span>{{ items.receiveTime }}</span></div>
                <div class="botts2">
                  <div v-if="items.type == 1">数量：{{ items.receiveNum }}</div>
                  <div v-if="items.type == 2">sn：{{ items.csn }}</div>
                  <div>接收人：{{ items.receiverName }}</div>
                </div>
              </div>
              <!-- <van-divider :hairline="false" /> -->
            </div>

          </template>
        </div>
      </van-list>
    </van-pull-refresh>
    <van-overlay :show="show" z-index="999999999999">
      <div class="wrapper">
        <div class="block">
          <img src="../../../assets/audit/blackxx.png" class="icon" @click="onClickIcon" />
          <p class="title">确认接收</p>
          <p class="sub_title">
            &nbsp;&nbsp;&nbsp;邮寄单号：<span>{{ currentItem.mailingNo }}</span>
          </p>
          <p class="sub_title">
            &nbsp;&nbsp;&nbsp;配件类型：<span>{{ currentItem.category }}</span>
          </p>
          <p v-if="!currentItem.csn" class="sub_title">&nbsp;&nbsp;&nbsp;数量：<span>{{ currentItem.operateNum }}</span>
          </p>
          <p v-if="currentItem.csn" class="sub_title">&nbsp;&nbsp;&nbsp;SN码：<span>{{ currentItem.csn }}</span></p>

          <div v-if="!currentItem.csn">
            <p class="sub_title">&nbsp;&nbsp;&nbsp;确认接收数量：</p>
            <div class="fileWarp" style="padding-left:20px">
              <van-field autocomplete="off" v-model="currentItem.receiveNum" name="数量" label="" placeholder="请填写数量"
                label-width="0" :border="true" type="number" :min="1" :rules="[{ required: true, message: '请填写数量' }]" />
            </div>
          </div>

          <div class="pass2" @click="onClickState(2)">确定</div>
        </div>
      </div>
    </van-overlay>
    <van-overlay :show="show2" z-index="999999999999">
      <div class="wrapper2">
        <div class="block">
          <img src="../../../assets/audit/x.png" class="icon" @click="onClickIcon2" />
          <p class="title">是否取消申请</p>
          <div class="reject" @click="onClickIcon2(1)"> 否 </div>
          <div class="pass" @click="onClickState2(2)"> 是 </div>
        </div>
      </div>
    </van-overlay>
    <!--  -->
    <van-popup class="bidPopUp" v-model="tan" closeable round>
      <p class="popUpTitle">类型</p>
      <div class="pickUnit" @click="datastu = true">
        <p>{{ fromlist.name }}</p>
      </div>
      <p class="popUpTitle" v-if="!fromlist.type || fromlist.type == 1">配件类型：</p>
      <p class="popUpTitle" v-if="fromlist.type == 2">产品类型：</p>
      <div class="pickUnit" @click="goods = true">
        <p>{{ fromlist.category }}</p>
      </div>
      <p class="popUpTitle" v-if="!fromlist.type || fromlist.type == 1">分派数量：</p>

      <van-field v-model="fromlist.operateNum" type="number" placeholder="请输入出入库数量" @blur="xianz"
        v-if="!fromlist.type || fromlist.type == 1" />
      <p class="popUpTitle" v-if="fromlist.type == 2">sn：</p>
      <div class="pickUnit" v-if="fromlist.type == 2" @click="showShipper = true">
        <p>{{ fromlist.csn }}</p>
      </div>

      <p class="popUpTitle">接收人：</p>
      <div class="pickUnit" @click="showUnit = true">
        <p>{{ fromlist.receiverName }}</p>
      </div>
      <div class="bot">
        <van-button class="unitButton1" type="primary" @click="subquxia">取消</van-button>
        <van-button class="unitButton" type="primary" @click="submit">分派</van-button>

      </div>
    </van-popup>
    <van-popup v-model="showShipper" position="bottom" :style="{ height: '30%' }">
      <van-picker show-toolbar title="sn" :columns="unitList" @confirm="onConfirmShipper" value-key="csn"
        @cancel="onCancelShipper" :default-index="defaultShipperIndex" />
    </van-popup>
    <van-popup v-model="showUnit" position="bottom" :style="{ height: '30%' }">

      <van-picker show-toolbar title="接收人" :columns="relist" @confirm="onConfirm" value-key="name" @cancel="onCancel" />
    </van-popup>

    <van-popup v-model="goods" position="bottom" :style="{ height: '30%' }">
      <van-picker show-toolbar title="配件类型" :columns="typegoodLi" @confirm="ongoods" :value-key="category"
        @cancel="cangoods" />
    </van-popup>
    <van-popup v-model="datastu" position="bottom" :style="{ height: '30%' }">
      <van-picker show-toolbar title="类型" :columns="leix" @confirm="centastu" @cancel="cangoods" value-key="name" />

    </van-popup>


    <!--  -->

    <div class="addBtn flex" @click="goAdd" v-if="active === 1">
      <img src="@/assets/workOrder/addFit.png">
      <span>新增核销申请</span>
    </div>
    <div class="addBtn flex" @click="tanlis" v-if="active === 2">
      <img src="@/assets/workOrder/addFit.png">
      <span>分派</span>
    </div>
    <Footer :page="1" :mineActive="1"></Footer>
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import Header from "@/components/Header";
import { getWorkFitList, cancelWorkFit, receiveWorkFit, stockad, WorkUserList, assignb } from "@/utils/network/interface"
export default {
  name: "",
  components: {
    Footer,
    Header,
  },
  props: {},
  data() {
    return {
      show: false,
      active: 0,
      tableList: [],
      loading: false,
      finished: false,
      refreshing: false,
      pageInfo: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      currentItem: {},
      show2: false,
      // 
      tan: false,
      showShipper: false,
      showUnit: false,
      goods: false,
      datastu: false,
      minDate: new Date(),
      maxDate: new Date(2050, 10, 1),
      typegoodLi: [],
      leix: [
        { name: "配件", type: 1 },
        { name: "产品", type: 2 }
      ],
      // 传参
      fromlist: {
        name: "",
        type: "",//类型
        category: "",//配件类型
        status: "",
        csn: "",
        operateNum: "",//出入库数量
        receiverWid: "",//接收人 wid
        receiverName: ""//接收人姓名 
      },
      // 所有的数据
      listdata: [],
      // 分配人员
      relist: [],
      // 对比的数量、
      nubdui: null,
      category: "category",
      snlist: [],
      // sn集合
      unitList: [],
      defaultShipperIndex: 0,
      // 
    };
  },
  computed: {},
  watch: {},
  created() {
    if ([0, 1].includes(this.$route.query.active)) {
      this.active = this.$route.query.active
    }
    this.WorkUserListro()
  },
  mounted() {

  },
  methods: {
    WorkUserListro() {
      WorkUserList().then(e => {
        console.log(e, "分配人员");
        let list = e.data
        let name = JSON.parse(localStorage.getItem("userInfo")).name
        // let named=name.name
        this.relist = list.filter(s => {
          return s.name != name
        })
        console.log(this.relist, "name");
      })
    },
    // 
    tanlis() {
      this.tan = true
      stockad().then(e => {
        console.log(e, "zidian");
        this.listdata = e.data
      })
    },
    onConfirmShipper(e) {
      this.fromlist.csn = e.csn
      this.fromlist.status = e.status
      this.showShipper = false
    },
    onCancelShipper() {
      this.showShipper = false

    },
    onCancel() {
      this.showUnit = false
    },
    onConfirm(e) {
      console.log(e);
      this.fromlist.receiverWid = e.wid
      this.fromlist.receiverName = e.name
      this.showUnit = false

    },
    // 配件类型确定
    ongoods(e) {
      console.log(e, "peijian");
      if (this.fromlist.type == 1) {
        this.fromlist.category = e.category
        this.fromlist.status = e.status
        this.nubdui = e.num
      } else if (this.fromlist.type == 2) {
        this.fromlist.category = e
        this.unitList = this.snlist.filter(ol => {
          return ol.category == e
        })
        console.log(this.unitList, "锅炉的sn");
      }

      this.goods = false
    },
    cangoods() {
      this.goods = false

    },
    ondatastu() {
      this.datastu = false
    },
    // 类型确定
    centastu(e) {
      this.fromlist = {
        name: "",
        type: "",//类型
        category: "",//配件类型
        status: "",
        csn: "",
        operateNum: "",//出入库数量
        receiverWid: "",//接收人 wid
        receiverName: ""//接收人姓名 
      }
      console.log(e);
      if (e.type == 1) {
        this.fromlist.name = e.name
        this.fromlist.type = e.type
        this.typegoodLi = this.listdata.filter(v => {
          return v.type == e.type
        })
        this.category = "category"
      } else if (e.type == 2) {
        this.fromlist.name = e.name
        this.fromlist.type = e.type
        let lv = this.listdata.filter(v => {
          return v.type == e.type
        })
        this.snlist = lv
        // 名字
        let names = lv.map(li => {
          return li.category
        })
        this.typegoodLi = [... new Set(names)]
        console.log(this.typegoodLi, "lv");
        this.category = ""
      }
      console.log(this.typegoodLi, "guolu");
      this.datastu = false

    },
    subquxia() {
      this.fromlist = {
        name: "",
        type: "",//类型
        category: "",//配件类型
        status: "",
        csn: "",
        operateNum: "",//出入库数量
        receiverWid: "",//接收人 wid
        receiverName: ""//接收人姓名 
      },
        this.tan = false
    },
    submit() {
      if (!this.fromlist.type) {
        this.$toast('请选择类型');
      } else if (!this.fromlist.category) {
        this.$toast('请选择类型名称');
      }
      else if (!this.fromlist.receiverName) {
        this.$toast('请选择接收人');
      } else if (this.fromlist.type == 1) {
        if (!this.fromlist.operateNum) {
          this.$toast('请输入出库数量');
        } else {
          assignb(this.fromlist).then(e => {
            console.log(e);
            this.tan = false
            this.getData();
            this.fromlist = {
              name: "",
              type: "",//类型
              category: "",//配件类型
              status: "",
              csn: "",
              operateNum: "",//出入库数量
              receiverWid: "",//接收人 wid
              receiverName: ""//接收人姓名 
            }
          })
        }
      } else if (this.fromlist.type == 2) {
        if (!this.fromlist.csn) {
          this.$toast('请选择csn');

        } else {
          assignb(this.fromlist).then(e => {
            console.log(e);
            this.tan = false
            this.getData();
            this.fromlist = {
              name: "",
              type: "",//类型
              category: "",//配件类型
              status: "",
              csn: "",
              operateNum: "",//出入库数量
              receiverWid: "",//接收人 wid
              receiverName: ""//接收人姓名 
            }
          })
        }
      }


    },
    xianz() {
      if (this.fromlist.operateNum > this.nubdui) {
        this.fromlist.operateNum = null
        this.$toast('输入数量不能大于库存');
      }
      console.log(this.fromlist.operateNum);
      console.log(this.nubdui);
    },
    // 
    onClickCell(item) {
      this.show = true
      this.currentItem = { ...item, receiveNum: 0 }
    },
    onClickCell2(item) {
      this.currentItem = item
      this.show2 = true
    },
    onClick(index) {
      // console.log(index);
      this.tableList = []
      this.getData()
      console.log(this.tableList)
    },
    onLoad() {
      setTimeout(() => {
        const { pageSize, pageNum } = this.pageInfo;
        let obj = { pageSize, pageNum };
        let params = {
          type: this.active + 1,
          ...obj,
        };
        getWorkFitList(params)
          .then((res) => {
            if (res.code === 200) {
              if (!res.rows)
                return (
                  (this.finished = true),
                  (this.loading = false),
                  (this.page.pageNum = 1),
                  (this.tableList = [])
                );
              this.tableList = this.tableList.concat(res.rows);
              this.pageInfo.pageNum++;
              this.pageInfo.total = res.total;
              this.loading = false;
              if (this.tableList.length >= res.total) {
                this.finished = true;
              }
            } else {
              this.finished = true;
            }
          })
          .catch((err) => { });
      }, 500);

    },
    getData() {
      let obj = { pageSize: 10, pageNum: 1 };
      let params = {
        type: this.active + 1,
        ...obj,
      };
      getWorkFitList(params)
        .then((res) => {
          this.refreshing = false;
          this.loading = false;
          if (res.code == 200) {
            if (!res.rows) {
              this.finished = true;
              this.loading = false;
              this.pageInfo.pageNum = 1;
              this.tableList = [];
            } else {
              this.finished = res.rows.length < 11
              this.tableList = res.rows;
              this.pageInfo.pageNum++;
              this.pageInfo.total = res.total;
            }
          } else {
            this.tableList = [];
          }
        })
        .catch((err) => { });
    },
    onRefresh() {
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.getData();
      this.pageInfo.pageNum++
    },
    onClickIcon() {
      this.show = false;
      this.currentItem = {}

    },
    onClickIcon2() {
      this.currentItem = {}
      this.show2 = false;
    },
    onClickState(type) {
      if (this.currentItem.receiveNum <= 0 && !this.currentItem.csn) return this.$toast({ position: 'top', message: "请填写数量" });
      receiveWorkFit({ id: this.currentItem.id, receiveNum: this.currentItem.receiveNum }).then(res => {
        if (res.code == 200) {
          this.$toast({
            type: "success",
            message: `接收成功`
          })
          this.show = false;
          this.getData()
        } else {
          this.currentItem = {}
          this.show2 = false;
          this.getData()
          this.$toast({
            type: "fail",
            position: "middle",
            message: res.msg
          });
        }
      })

    },
    onClickState2(type) {
      if (type == 1) {
        return
      } else {
        cancelWorkFit({ id: this.currentItem.id }).then(res => {
          if (res.code === 200) {
            this.$toast.success("取消申请成功")
            this.getData()
            this.currentItem = {}
            this.show2 = false;
          } else {
            this.currentItem = {}
            this.show2 = false;
            this.getData()
            this.$toast({
              type: "fail",
              position: "middle",
              message: res.msg
            });
          }
        })
      }

    },
    goAdd() {
      this.$router.push({
        path: "/workOrder/parts/add"
      })
    },
  },
};
</script>

<style lang="less" scoped>
.parts {
  min-height: 100vh;

  .head {
    position: fixed;
    z-index: 999999;
    width: 100%;
    height: 104px;
    background: #44b1f9;
    padding-top: 36px;

    .title {
      font-size: 16px;
      text-align: center;
      line-height: 25px;
      height: 25px;
      color: #fff;
    }
  }

  .table_view {
    width: 100%;
    margin-top: 114px;
    min-height: calc(100vh - 184px);

    .table_cell {
      width: 94%;
      min-height: 107px;
      background-color: white;
      border-radius: 5px;
      margin: 0 auto;
      margin-top: 17px;
      padding-bottom: 13px;

      // 新

      .oddNumbers {
        padding: 10px;
        background: url(../../../assets/workOrder/oddnub.png) no-repeat;
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        font-size: 14px;
        font-family: Source Han Sans CN, Source Han Sans CN-Medium;
        font-weight: 500;
        color: #333333;

        .imgicon {
          width: 25px;
          height: 25px;
        }
      }

      .bottombox:last-child .van-divider {
        display: none;
      }

      .van-divider {
        margin: 20px 15px;

      }


      // 新
      .head_info {
        height: 42px;
        width: 100%;
        // background: linear-gradient(79deg,
        //     rgba(68, 177, 249, 0.12) 0%,
        //     rgba(255, 255, 255, 0.12) 100%);
        border-radius: 5px 5px 0px 0px;
        padding-left: 13px;
        padding-top: 14px;
        padding-right: 13px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 30px;

        .typebox {
          display: flex;
          align-items: center;
        }

        .type {
          width: 40px;
          height: 40px;
          background: url(../../../assets/workOrder/pj.png) no-repeat;
          background-size: 100% 100%;
          // float: left;
        }

        .type1 {
          width: 40px;
          height: 40px;
          background: url(../../../assets/workOrder/cp.png) no-repeat;
          background-size: 100% 100%;
          // float: left;
        }

        .sub-title {
          margin-left: 5px;
        }

        .state1 {
          // min-width: 54px;
          // width: 54px;
          // max-width: fit-content;
          height: 23px;
          background: #44b1f9;
          border-radius: 5px;
          color: white;
          line-height: 23px;
          text-align: center;
          padding: 0 10px;
          font-size: 12px;
          display: flex;
          align-items: center;
          justify-content: center;

          // float: right;
          // margin-top: -4px;
        }

        .state2 {
          min-width: 54px;
          height: 23px;
          padding: 0 10px;
          background: rgba(153, 153, 153, 0.15);
          border-radius: 5px;
          color: rgba(153, 153, 153, 1);
          margin-top: -4px;
          line-height: 23px;
          text-align: center;
          border: 1px solid #999999;
          font-size: 12px;
          // float: right;
        }

        .state3 {
          width: 55px;
          height: 20px;
          // margin-top: -8px;
          // float: right;
          background: url(../../../assets/workOrder/js.png) no-repeat;
          background-size: 100% 100%;
        }
      }

      .botts {
        padding: 0 26px 4px;

        .botts1 {
          color: #999999;
          margin-bottom: 8px;
        }

        .botts2 {
          color: #999999;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
      }

      .num {
        margin-left: 13px;
        margin-top: 15px;
        color: #5e5e5ea9;

        span {
          color: #44b1f9;
        }
      }




      .starTime {
        margin-left: 13px;
        margin-top: 11px;
        color: #5e5e5ea9;

        span {
          color: #5e5e5e;
        }
      }

      .starTimedggbox {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-top: 15px;
        padding-right: 20px;

        .starTimedgg {
          width: 90px;
          height: 32px;
          border: 1px solid #44B1F9;
          text-align: center;
          line-height: 32px;
          // float: right;
          border-radius: 30px;
          color: #44B1F9;
          font-size: 14px;

        }
      }

    }
  }

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    z-index: 9999999;

    .block {
      width: 269px;
      min-height: 269px;
      padding-bottom: 20px;
      background: url("../../../assets/audit/hxBg.png") 0 0 no-repeat;
      background-size: 269px 60px;
      background-color: white;
      border-radius: 10px;

      .icon {
        width: 15px;
        height: 15px;
        float: right;
        margin-right: 16px;
        margin-top: 21px;
      }

      .title {
        font-size: 16px;
        color: black;
        text-align: center;
        margin-top: 45px;
        font-weight: 700;
        margin-bottom: 29px;
      }

      .sub_title {
        margin: 0 auto;
        margin-bottom: 13px;
        border-left: 2px solid #44b1f9;
        font-size: 13px;
        color: black;
        width: 80%;

        span {
          color: #5e5e5e;
        }
      }

      .img_arr {
        // display: flex;
        width: 80%;
        margin: 0 auto;

        .imageItem {
          margin-right: 9px;
          margin-bottom: 9px;
        }
      }

      .reject {
        width: 87px;
        height: 28px;
        border: 1px solid #999999;
        border-radius: 5px;
        color: #999999;
        text-align: center;
        line-height: 28px;
        float: left;
        margin-top: 20px;
        margin-left: 40px;
      }

      .pass {
        width: 87px;
        height: 28px;
        border-radius: 5px;
        color: white;
        text-align: center;
        line-height: 28px;
        background-color: #44b1f9;
        float: left;
        margin-top: 20px;
        margin-left: 20px;
      }

      .pass2 {
        width: 142px;
        height: 28px;
        border-radius: 5px;
        color: white;
        text-align: center;
        line-height: 28px;
        background-color: #44b1f9;
        margin: 70px auto 0;
      }
    }
  }

  .addBtn {
    position: fixed;
    right: 0;
    bottom: 100px;
    width: 140px;
    height: 34px;
    background: rgba(68, 177, 249, 0.5);
    border-radius: 37px 0 0 37px;
    color: #024E80;
    font-size: 12px;
    padding: 6px;
    align-content: center;
    align-items: center;

    img {
      width: 22px;
      height: 22px;
      margin-right: 10px;
    }
  }

  .wrapper2 {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    z-index: 9999999;

    .block {
      width: 269px;
      height: 165px;
      background: url("../../../assets/icon/layoutBg.png") 0 0 no-repeat #fff;
      background-size: 269px 61px;
      border-radius: 10px;
      position: relative;

      .icon {
        width: 11px;
        height: 11px;
        float: right;
        right: 16px;
        top: 25px;
        position: absolute;
      }

      .title {
        font-size: 18px;
        font-family: Source Han Sans CN, Source Han Sans CN-Medium;
        font-weight: 500;
        color: #333333;
        text-align: center;
        margin-top: 45px;
        margin-bottom: 55px;
        line-height: 1;
      }

      .reject {
        width: 87px;
        height: 28px;
        border: 1px solid #f7b346;
        border-radius: 5px;
        color: #f7b346;
        text-align: center;
        line-height: 28px;
        float: left;
        margin-left: 40px;
      }

      .pass {
        width: 87px;
        height: 28px;
        border-radius: 5px;
        color: white;
        text-align: center;
        line-height: 28px;
        background-color: #44b1f9;
        float: left;
        margin-left: 20px;
      }
    }
  }

  //
  .bidPopUp {
    padding: 20px;
    width: 80%;
    height: 420px;

    .popUpTitle {
      font-size: 14px;
      font-family: Source Han Sans CN, Source Han Sans CN-Medium;
      font-weight: 600;
      text-align: left;
      color: #333333;
      line-height: 22px;
      margin-bottom: 10px;
    }

    .pickUnit {
      height: 30px;
      background: #eeeeee;
      border: 1px solid #44b1f9;
      border-radius: 5px;
      line-height: 30px;
      background: url("../../../assets/accountant/selectDown.png") calc(100% - 10px) center no-repeat;
      background-size: 12px 10px;
      margin-bottom: 25px;
      padding-left: 10px;
      padding-right: 25px;
      font-size: 14px;

      p {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }

    .unitButton {
      width: 142px;
      height: 28px;
      background: #44b1f9;
      border-radius: 5px;
      display: block;
      margin: 0 auto;
      border: 1px solid #44b1f9;
    }

    .bot {
      width: 100%;
      display: flex;
      align-items: center;

      .unitButton {
        width: 35%;
        height: 28px;
        background: #44b1f9;
        border-radius: 5px;
        display: block;
        margin: 0 auto;
        border: 1px solid #44b1f9;
        line-height: 28px;
      }

      .unitButton1 {
        width: 35%;
        height: 28px;
        background: #999999;
        border-radius: 5px;
        display: block;
        margin: 0 auto;
        border: 1px solid #999999;
        line-height: 28px;
      }
    }

    .van-cell {
      padding: 4px 0;
      padding-left: 6px;
      border: 1px solid #44b1f9;
      border-radius: 6px;
      margin-bottom: 6px;
    }
  }
}
</style>

<style lang="less">
.fileWarp {
  padding: 0 20px;

  .van-cell {
    padding-left: 20px;

    .van-cell__value {
      border: 1px solid #44B1F9;
      border-radius: 10px;
      padding: 8px 10px;
    }

  }
}
</style>